import Vuex from 'vuex'
import axios from 'axios'
import Vue from 'vue'
Vue.use(Vuex)
axios.defaults.baseURL = process.env.VUE_APP_SERVICE_API; //'https://localhost:7156/';
//axios.defaults.baseURL = 'https://wuttanavij.azurewebsites.net/'
//axios.defaults.baseURL = 'https://wellekpharma.azurewebsites.net/'

axios.defaults.headers.common["Authorization"]="Bearer " + window.localStorage.token;
import product from '@/store/modules/homeProduct';
import history from '@/store/modules/historyProduct';
import ads from '@/store/modules/adsAdmin';
import productView from '@/store/modules/homeProductView';
import { Base64 } from 'js-base64';
const store = new Vuex.Store({
    state: {
        token: '',
        running: '',
        shopCounter: 0,
        orderId: 0,
        api: false,
        emptyImage: 'data:image/png;base64,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'
    },
    mutations: {
        setToken(state, tokenKey) {
            state.token = tokenKey;
        },
        setCalling(state) {
            state.running = '0';
        },
        setApi(state) {
            state.api = true;
        }
    },
    actions: {
        getProfile(){
            return new Promise((resolve, reject) => {
                axios.get('Cloud/Securitys/profile').then((result) => {
                    resolve(result.data);
                }).catch((error) => { reject(error); });
            });
        },
        resetStorage(context){
            context.state.orderId = 0;
            context.state.token = '';
            context.state.running = '';

            const remm = window.localStorage.getItem('remm');
            window.localStorage.clear();
            window.localStorage.setItem('remm',remm??'');
            
        },
        authentication(context, data){
            return  new Promise((resolve, reject) => {
                axios.post('Cloud/Securitys/Authenticate', data, { 'Content-Type': 'application/json' }).then((result) => {
                    context.commit('setToken', result.data.token);
                    localStorage.setItem('token', result.data.token);
                    localStorage.setItem('orderNo', result.data.orderId);
                    context.state.orderId = result.data.orderId;
                    axios.defaults.headers.common["Authorization"]="Bearer " + result.data.token;
                    resolve(result.data.directUrl);
                }).catch((error) => { 
                    console.log(error);
                    reject(error); });
            })
        },
        registerMember(context, data) {
            return new Promise((resolve, reject) => {
                axios.post('Cloud/Reqisters/register', data, { 'Content-Type': 'application/json' }).then((result) => {
                    context.commit('setApi');
                    resolve(result.data);
                }).catch((error) => { reject(error); })
            });
        },
        getReguester(context,find) {
            console.log('xxx' + find);
            return new Promise((resolve, reject) => {
                axios.get('Cloud/Reqisters/requester/?find=' + find.f + '&mode=' + find.p).then((result) => {
                    context.commit('setApi');
                    resolve(result.data);
                }).catch((error) => { reject(error); });
            });
        },
        getProduct(context, data) {
            return new Promise((resolve, reject)  =>  {
                 axios.get('Cloud/ProductLists/ProductList?find=' + data.find + "&mode=" + data.mode).then((resullt) => {
                    context.commit.setCalling();
                    resolve(resullt.data);
                }).catch((error) => { reject(error); });
            });
        },
        getActivityBanner() {
            return new Promise( (resolve, reject) => {
                axios.get('').then((result) => {
                    resolve(result.data);
                }).catch((error) => { reject(error); });
            });
        },
        getPriceLevel() {
            return new Promise((resolve, reject) => {
                axios.get('Cloud/Reqisters/getPriceLevel').then((result) => {
                    resolve(result.data);
                }).catch((error) => { reject(error); });
            });
        },
        approved(context, data) {
            return new Promise((resolve, reject) => {
                axios.post('Cloud/Reqisters/updatePriceWithCustomer', data, { 'Content-Type': 'application/json' }).then((result) => {
                    resolve(result.data);
                }).catch((error) => { reject(error) });
            });
        },
        deleteByCustomer(context, data) {
            return new Promise((resolve, reject) => {
                axios.post('Cloud/Reqisters/deleteCustomer', data, { 'Content-Type': 'application/json' }).then((result) => {
                    resolve(result.data);
                }).catch((error) => { reject(error); });
            });
        },
        getStockItems(context, find){
            return new Promise((resolve, reject)=>{
                axios.get('Cloud/ProductLists/StockItemLists/?find=' + Base64.encode(find.f) + '&mode=' + find.p).then((result) => {
                    context.commit('setApi');
                    resolve(result.data);
                }).catch((error) => { reject(error); });
            });
        },
        getCustomerList(context,find) {
            return new Promise((resolve, reject) => {
                axios.get('Cloud/Reqisters/getCustomerList/?find=' + find.f + '&mode=' + find.p).then((result) => {
                    context.commit('setApi');
                    resolve(result.data);
                }).catch((error) => { reject(error); });
            });
        },
        getPromotionProduct(context, stockid){
            return new Promise((resolve, reject)=>{
                axios.get('Cloud/ProductLists/Promotion/?find=' + stockid.f).then((result) => {
                    context.commit('setApi');
                    resolve(result.data);
                }).catch((error) => { reject(error); });
            });
        },
        getImageProduct(context, stockid){
            return new Promise((resolve, reject)=>{
                axios.get('Cloud/ProductLists/ProductImage/?find=' + stockid.f).then((result) => {
                    context.commit('setApi');
                    resolve(result.data);
                }).catch((error) => { reject(error); });
            });
        },
        getWarehouseProduct(context, stockid){
            return new Promise((resolve, reject)=>{
                axios.get('Cloud/ProductLists/Warehouse/?find=' + stockid.f).then((result) => {
                    context.commit('setApi');
                    resolve(result.data);
                }).catch((error) => { reject(error); });
            });
        },
        uploadImageStockItem(context, data){
            return new Promise((resolve, reject)=>{
                axios.post('Cloud/ProductLists/UploadStock', data, { 'Content-Type': 'application/json' }).then((result) => {
                    context.commit('setApi');
                    resolve(result.data);
                }).catch((error) => { reject(error); });
            });
        },
        delImageProduct(context, stockid){
            return new Promise((resolve, reject)=>{
                axios.get('Cloud/ProductLists/DelProductImage/?find=' + stockid.f + '&mode=' + stockid.p).then((result) => {
                    context.commit('setApi');
                    resolve(result.data);
                }).catch((error) => { reject(error); });
            });
        },
        updateProductItem(context, data){
            return new Promise((resolve, reject)=>{
                axios.post('Cloud/ProductLists/saveStockItem', data, { 'Content-Type': 'application/json' }).then((result) => {
                    context.commit('setApi');
                    resolve(result.data);
                }).catch((error) => { reject(error); });
            });
        },
        getWareHouseStore(context){
            return new Promise((resolve, reject)=>{
                axios.get('Cloud/Reqisters/getWearHouse').then((result) => {
                    context.commit('setApi');
                    resolve(result.data);
                }).catch((error) => { reject(error); });
            });
        },
        getUserList(context, data){
            return new Promise((resolve, reject)=>{
                axios.get('Cloud/Reqisters/getUserList/?find=' + data.f + '&mode=').then((result) => {
                    context.commit('setApi');
                    resolve(result.data);
                }).catch((error) => { reject(error); });
            });
        },
        getGroupUserList(context){
            return new Promise((resolve, reject)=>{
                axios.get('Cloud/Reqisters/getGroup').then((result) => {
                    context.commit('setApi');
                    resolve(result.data);
                }).catch((error) => { reject(error); });
            });
        },
        addUserByCustomer(context, data){
            return new Promise((resolve, reject)=>{
                axios.post('Cloud/Reqisters/recordUser', data, { 'Content-Type': 'application/json' }).then((result) => {
                    context.commit('setApi');
                    resolve(result.data);
                }).catch((error) => { reject(error); });
            });
        },
        delUserByCustomer(context, data){
            return new Promise((resolve, reject)=>{
                axios.post('Cloud/Reqisters/delUserByCustomer', data, { 'Content-Type': 'application/json' }).then((result) => {
                    context.commit('setApi');
                    resolve(result.data);
                }).catch((error) => { reject(error); });
            });
        },
        deleteCustomer(context, data){
            return new Promise((resolve, reject)=>{
                axios.post('Cloud/Reqisters/deleteCustomerOnly', data, { 'Content-Type': 'application/json' }).then((result) => {
                    context.commit('setApi');
                    resolve(result.data);
                }).catch((error) => { reject(error); });
            });
        },
        updateCustomer(context,data){
            return new Promise((resolve, reject)=>{
                axios.post('Cloud/Reqisters/updateCustomer', data, { 'Content-Type': 'application/json' }).then((result) => {
                    context.commit('setApi');
                    resolve(result.data);
                }).catch((error) => { reject(error); });
            });
        },
        getBookBankPayment(){
            return new Promise((resolve, reject)=>{
                axios.get('Cloud/Historys/getBooking').then((result) => {
                    resolve(result.data);
                }).catch((error) => { reject(error); });
            });
        },
        setBookBankPayment(context, data){
            return new Promise((resolve, reject)=>{
                axios.post('Cloud/Historys/senderBooking', data, { 'Content-Type': 'application/json' }).then((result) => {
                    context.commit('setApi');
                    resolve(result.data);
                }).catch((error) => { reject(error); });
            });
        },
        getPolicy(){
            return new Promise((resolve, reject)=>{
                axios.get('Cloud/Securitys/policy').then((result) => {
                    resolve(result.data);
                }).catch((error) => { reject(error); });
            });
        },
        submitPolicy(context){
            return new Promise((resolve, reject)=>{
                axios.post('Cloud/Securitys/updatepolicy', { 'Content-Type': 'application/json' }).then((result) => {
                    context.commit('setToken', result.data);
                    localStorage.setItem('token', result.data);
                    axios.defaults.headers.common["Authorization"]="Bearer " + result.data;
                    resolve(result.data);
                }).catch((error) => { reject(error); });
            });
        },
        generalRegister(context, data){
            return new Promise((resolve, reject)=>{
                axios.post('Cloud/Reqisters/genregister', data , { 'Content-Type': 'application/json' }).then((result) => {
                    context.commit('setApi');
                    resolve(result.data);
                }).catch((error) => { reject(error); });
            });
        },
        forgetPassword(context, data){
            return new Promise((resolve, reject)=>{
                axios.post('Cloud/Securitys/forgetPassword', data, {'Content-Type': 'application/json'}).then((result)=>{
                    context.commit('setApi');
                    resolve(result.data);
                }).catch((error)=>{reject(error);});
            });
        },
        settingPassword(context, data){
            context.commit('setToken', data);
            localStorage.setItem('token', data);
            //axios.defaults.headers.common["Authorization"]="Bearer " + data;
            return new Promise((resolve, reject)=>{
                axios.post('Cloud/Securitys/resetOnly', data, {'Content-Type': 'application/json'}).then((result)=>{
                    context.commit('setApi');
                    resolve(result.data);
                }).catch((error)=>{reject(error);});
            });
        },
        checkVerify(context, data){
            axios.defaults.headers.common["Authorization"]="Bearer " + data;
            return new Promise((resolve, reject)=>{
                axios.get('Cloud/Securitys/autoCommit').then((result) => {
                    resolve(result.data);
                }).catch((error) => { reject(error); });
            });
        }
    },
    modules:{
        homeProduct: product,
        historyProduct: history,
        adsProduct: ads,
        homeProductView: productView
    }
  })

  export default store